import ProjectTracker from './containers/ProjectTracker';
import requireAuth from '../../../utils/requireAuth';

export const projectTrackerRoutes = [
    {
        path: '/technical/planner-tracker/tracker',
        component: requireAuth(ProjectTracker),
        key: 'ProjectTracker',
    },
];
